const API_BASE_URL = import.meta.env.VITE_API_URL?.replace(/\/$/, "") ?? "";

export const resolveApiUrl = () => {
  if (API_BASE_URL.length > 0) {
    return API_BASE_URL;
  }

  if (typeof window !== "undefined") {
    const { protocol, hostname, port } = window.location;
    if (port === "5173" || port === "4173") {
      return `${protocol}//${hostname}:3001`;
    }

    return window.location.origin;
  }

  return "http://localhost:3001";
};

export const buildApiUrl = (path: string) => {
  const base = resolveApiUrl();
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return new URL(normalizedPath, base).toString();
};

export const withClientTimezoneHeader = (
  headers: Record<string, string> = {},
) => {
  if (typeof Intl === "undefined") {
    return headers;
  }

  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  if (timezone) {
    headers["X-HKL-Timezone"] = timezone;
  }

  return headers;
};
